<!-- wrapper tag for the whole app -->
<template>
  <div :key="componentKey" :class="_cssClass">
    <div
      v-show="contextMenu"
      class="lightbox"
      @keydown.esc="clearContext"
      @click.stop="clearContext"
    ></div>
    <div
      v-show="contextMenu"
      id="app-context-menu"
      ref="contextContainer"
      draggable="true"
      :class="_contextMenuClass"
      :style="_position"
    >
      <div class="context-header">
        <h4
          v-if="contextMenu"
          class="context-title"
          data-label-type="sub-heading"
        >
          {{ contextMenu.items.find((item) => !item.callback).text }}
          <a href="#" class="copy-link" @click.stop.prevent="copyTextClipboard"
            >Copy to clipboard</a
          >
        </h4>
        <a
          data-label="context-close"
          role="button"
          tabindex="0"
          class="context-close cat-btn simple link"
          icon-only=""
          @click.stop="clearContext"
          ><span
            aria-hidden="true"
            role="img"
            aria-label="Close"
            class="mln mrn cat-icon icon icon-times-light"
          ></span
        ></a>
      </div>

      <!-- TODO possibly move this to its own component for context menu -->
      <ul v-if="contextMenu" role="menu" class="context-items">
        <li
          v-for="(item, idx) in contextMenu.items"
          :key="idx + 1"
          role="presentation"
        >
          <a
            v-if="item.callback"
            class="context-item block-block"
            role="menuitem"
            @click="invoke($event, item.callback)"
            ><span class="item-title">{{ item.text }}</span>
            <span class="item-additional">{{ item.additionalText }}</span>
          </a>
          <!--          <h4 v-else class="context-title mbs" data-label-type="sub-heading">-->
          <!--            {{ item.text }}-->
          <!--          </h4>-->
        </li>
      </ul>
    </div>
    <slot></slot>
    <!--    <PortalTarget name="layout-body-end" multiple slim />-->
    <!--  moved to mainlayout.groovy  -->
    <!--    <div id="layout-body-end"></div>-->
  </div>
</template>

<script>
import { defineComponent } from "vue";
import mitt from "mitt";
const emitter = mitt();

export default defineComponent({
  name: "CatApp",
  props: {
    id: {
      type: String,
      default: "app"
    },
    appCode: [String, Number],
    svcTsxId: [String, Number],
    ctxId: [String, Number],
    dark: {
      type: Boolean,
      default: false
    }
  },
  provide: function () {
    return {
      emitter: emitter,
      showContext: this.showContext,
      clearContext: this.clearContext
    };
  },
  data: function () {
    return {
      contextMenu: null,
      position: null,
      modal: null,
      xpos: null,
      ypos: null,
      componentKey: 0
    };
  },
  methods: {
    showContext: function (event, menu) {
      let t = this;
      // console.log("Show context", event);
      this.xpos = event.pageX;
      this.ypos = event.pageY;
      this.contextMenu = menu;
      this.$nextTick(function () {
        t.fixCoords(event);
      });
    },
    clearContext: function (event) {
      emitter.emit("contextClose", { open: false });
      this.contextMenu = null;
    },
    invoke: function (event, callback) {
      this.contextMenu = null;
      callback();
    },
    copyTextClipboard: function () {
      if (this.contextMenu) {
        const fullText = this.contextMenu.items.find(
          (item) => !item.callback
        ).text;
        const match = fullText.match(/:(.*?)\(/);
        if (match && match[1]) {
          const textToCopy = match[1].trim(); // Trimming to remove any leading or trailing whitespace
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(textToCopy);
          }
        }
      }
    },
    fixCoords: function (event) {
      let xx, yy;
      let pureY = event.clientY;
      if (event) {
        let sizeX = this.$refs.contextContainer.clientWidth;
        let sizeY = this.$refs.contextContainer.clientHeight;
        xx =
          event.pageX + sizeX > window.innerWidth
            ? event.pageX - sizeX
            : event.pageX;
        yy =
          pureY + sizeY > window.innerHeight
            ? event.pageY - sizeY
            : event.pageY;
        this.xpos = xx;
        this.ypos = yy;
      }
    },
    forceRerender() {
      this.componentKey += 1; // Changing the key forces a complete re-render
    }
  },
  computed: {
    _position: function () {
      return {
        left: this.xpos + "px",
        top: this.ypos + "px",
        resize: "both"
      };
    },
    _cssClass: function () {
      return {
        "cat-app": true,
        jsniperEnabled: window["Catalyst"].jsniper
      };
    },
    _contextMenuClass: function () {
      var result = {
        "context-menu": true
      };

      if (this.contextMenu && this.contextMenu.css)
        result[this.contextMenu.css] = true;

      return result;
    }
  },
  mounted: function () {
    jQuery(this.$refs.contextContainer).draggable();

    /*
     * As of chrome 96 BFCache is enabled by default
     * It's important to re-render the component tree when returning from BFCache
     * as the state will be stale.
     */
    window.addEventListener("pageshow", (event) => {
      if (event.persisted) {
        // We have resumed from BFCache so we should re-render the component tree
        this.forceRerender();
      }
    });

    // For potential iframe, after content is truly ready (e.g. after Vue mounted, or app finished loading)
    window.parent.postMessage(
      JSON.stringify({
        type: "embeddedMessage",
        action: "iframe-ready",
        success: true
      }),
      window.origin
    );
  }
});
</script>
